module.exports = __webpack_public_path__ + "static/media/3DPPA18.87ff0701.jpg";